export const en = {
    'add-minus-keywords-pack-success': 'Created set'
};
